
	// @ts-nocheck
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	
	
	import DirectoryTree from '../components/DirectoryTree.vue'
	import DocumentList from '../components/DocumentList.vue'

	import PageRequest from '@/store/entities/page-request'
	class PageNewsRequest extends PageRequest {
		tagType: number;
		tagId: number
	}
	@Component({
		components: {
			DirectoryTree,
			DocumentList
		}
	})
	export default class NewsDetail extends AbpBase {
		noticeList: Array < any >= new Array < any > ();
		totalCount: Number = 0;
		currentPage: Number = 1;
		pageSize: Number = 0;
		pagerequest: PageNewsRequest = new PageNewsRequest();
		links: Array < any >= new Array < any > ();
		treeData:Array < any >= new Array < any > ();
		selectedId:Number=0;
		currentDocuments:Array < any >= new Array < any > ();
		loading:boolean=false;
		did: Number = 0;
		
		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.did != from.query.did) {
				location.reload();
			}
		}
		
		handleSelect(id){
			this.selectedId=id;
			console.log(id)
			this.getDocumentByDid();
		}
		getDocumentByDid() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getDocumentByDid',
				id: this.selectedId
			}).then(res => {
				console.log(res);			
				that.currentDocuments=res;		
			})
		}
		downloadByName(name){
			var that = this;
			
			this.$store.dispatch({
				type: 'app/downloadDirDoc',
				data: {
					Id:this.selectedId,
					filePath:name
				}
			}).then(res => {
				console.log(res);			
				
			})
		}
		

		
		getAllLinks() {
			var that = this;
			var request = {
				maxResultCount: 1000,
				skipCount: 0,	
				isVisible:true,
			}
			this.$store.dispatch({
				type: 'app/getAllLinks',
				data: request
			}).then(res => {
				console.log(res);				
				that.links = res.items;				
			})
		}
		getAllDirectories() {
			var that = this;
			var request = {
				maxResultCount: 1000,
				skipCount: 0,
			    isVisible:true,
				isApp:true
			}
			this.$store.dispatch({
				type: 'app/getAllDirectories',
				data: request
			}).then(res => {
				console.log(res);				
				var result = res.items;	
				this.treeData=that.buildTree(result);
				if(that.selectedId!=0){
					that.handleSelect(that.selectedId);
				}
			})
		}
		buildTree(list, parentId = null) {
			var that=this;
		  return list
		    .filter(item => item.parentId === parentId)
		    .map(item => ({
		      ...item,
		      children: that.buildTree(list, item.id),
			  _showChildren:true,			 
		    }))
		}
		filterVisibleDirectories(dirs) {
		      return dirs
		        .filter(dir => dir.isVisible === 1)
		        .map(dir => ({
		          ...dir,
		          children: dir.children ? this.filterVisibleDirectories(dir.children) : undefined,
		        }));
		    }
		
		created() {			
			if (this.$route.query.did && (this.$route.query.did as number) > 0) {
				this.selectedId = parseInt(this.$route.query.did);				
			}
			this.getAllLinks();
			this.getAllDirectories();
		}
	};
